// extracted by mini-css-extract-plugin
module.exports = {"content":"SessionPicture_style_content__2mwQx","contentText":"SessionPicture_style_contentText__32QSz"};